
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import React from 'react';

const metrics = [
  { value: '50+', label: 'Brands Served' },
  { value: '5M+', label: 'Impressions Generated' },
  { value: '98%', label: 'Client Retention' },
  { value: '3x', label: 'Average ROI' },
];

export default function Metrics() {
  // Removed the generic type argument – it isn’t valid in plain JavaScript/JSX and caused a syntax error.
  const { ref, isVisible } = useScrollAnimation();

  // Defensive check – if the hook fails to provide a ref, avoid rendering to prevent runtime crashes.
  if (!ref) {
    console.error('Metrics component: useScrollAnimation did not return a ref.');
    return null;
  }

  return (
    <section ref={ref} className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e34eaae8e916ff607627228ccb10ac48.jpg"
          alt="Metrics background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-slate-900/80"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <div
              key={metric.label}
              className={`text-center transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${index * 150}ms` : '0ms' }}
            >
              <p
                className="text-4xl lg:text-5xl font-bold text-white mb-2"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {metric.value}
              </p>
              <p className="text-sm text-white/70 uppercase tracking-wider">{metric.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
